import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";


const vUI_Hierarchy_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_HIERARCHY_ID:  {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Wb Hierarchy Id',      alignment: HorizAlignment.Left},  domainOptions: {}},
    HIERARCHY_ID:     {type: SearchProviderFieldType.string, renderOptions: {columnName: 'ID',                   alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50}},
    HIERARCHY_NAME:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Name',                 alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50}},
    MDSET_ID:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Master Data Set Id',   alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50}},
    MDSET_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Master Data Set Name', alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50, profileId: "default", bUseSearchProvidersDistinctValues: true}},
    ENTITY_DIMENSION: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Domain',               alignment: HorizAlignment.Left }, domainOptions: {domainIds: ['ENTITY_DIMENSION'], useIdAsKey: true, maxLength: 20, domainItemSubCode: 'Hierarchy'}},
    HIERARCHY_STATUS: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Status',               alignment: HorizAlignment.Left }, domainOptions: {domainIds: ['HierarchyStatus'],  useIdAsKey: true }},
    HIERARCHY_WORKFLOW_MODE: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Workflow',      alignment: HorizAlignment.Left }, domainOptions: {domainIds: ['HIERARCHY_WORKFLOW_MODE'],  useIdAsKey: true,  }},
    EFFECTIVE_DATE_POLICY: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Date Policy',      alignment: HorizAlignment.Left }, domainOptions: {domainIds: ['EFFECTIVE_DATE_POLICY'],  useIdAsKey: true }},
    STAGING_POLICY: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Staging Policy',      alignment: HorizAlignment.Left }, domainOptions: {domainIds: ['STAGING_POLICY'],  useIdAsKey: true }},
    EXTRACT_ATTRIBUTES_IND: {type: SearchProviderFieldType.boolean, renderOptions: {columnName: 'Generate Attributes',    alignment: HorizAlignment.Left }, domainOptions: {}},
    EXTRACT_ENTITIES_IND: {type: SearchProviderFieldType.boolean, renderOptions: {columnName: 'Generate Entities',    alignment: HorizAlignment.Left }, domainOptions: {}},
    ENTERPRISE_NODES_IND: {type: SearchProviderFieldType.boolean, renderOptions: {columnName: 'Enterprise Nodes',    alignment: HorizAlignment.Left }, domainOptions: {}},
    CREATED_STATUS:       {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Created Status', alignment: HorizAlignment.Left }, domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }}

const HierarchySearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_HIERARCHY_ID',
        id_ui: 'HIERARCHY_ID',
        name: 'HIERARCHY_NAME'

    },

    searchProviderFields: vUI_Hierarchy_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Hierarchy_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Hierarchy_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

};

const HierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by ID, Name",
    renderOptions: {ui5SourceId: "HierarchySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'HIERARCHY_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'HIERARCHY_NAME', renderOptions: {}},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Domain', searchProviderFieldId: 'ENTITY_DIMENSION', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'HIERARCHY_ID', 'HIERARCHY_NAME', 'ENTITY_DIMENSION',
        'HIERARCHY_STATUS','CREATED_STATUS', 'HIERARCHY_WORKFLOW_MODE', 'ENTERPRISE_NODES_IND', 'EFFECTIVE_DATE_POLICY','STAGING_POLICY',
        {fields: ['MDSET_NAME', 'MDSET_ID'], columnTitle: "MD Set", seperator: " - "},
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],
    profileHiddenFields: ['CREATED_STATUS', 'ENTERPRISE_NODES_IND', 'EFFECTIVE_DATE_POLICY','STAGING_POLICY','EXTRACT_ATTRIBUTES_IND','EXTRACT_ENTITIES_IND'],

    profileSearchProvider: HierarchySearchProviderBasic,
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const HierarchySearch: ISearch = {
    searchName: "Find Hierarchy",
    renderOptions: {ui5ResourceId: "HierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [HierarchySearchProfileByName]
};

_.forEach(vUI_Hierarchy_Search_Fields, (colSpec) => {
    if(colSpec.domainOptions.bUseSearchProvidersDistinctValues && !colSpec.domainOptions.search)
        colSpec.domainOptions.search = HierarchySearch
})

PAEnvironment.registerBusinessObjectSearch("HierarchyBO", "Hierarchy", HierarchySearch, "Hierarchy Search")

export {HierarchySearch}